import { render, staticRenderFns } from "./ViewCompanyRequest.vue?vue&type=template&id=1d38dfb8"
import script from "./ViewCompanyRequest.vue?vue&type=script&lang=js"
export * from "./ViewCompanyRequest.vue?vue&type=script&lang=js"
import style0 from "./ViewCompanyRequest.vue?vue&type=style&index=0&id=1d38dfb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports